import React from 'react';
import { Bar } from 'react-chartjs-2';
import Spinner from '../ui/Spinner/Spinner';
import { getVisitorsChartData, getDocumentChartData } from '../../utils/utils';

interface PROPS {
  loading: boolean;
  months: string[];
  documentData: number[];
  userData: number[];
}

const Charts = ({ loading, months, documentData, userData }: PROPS): JSX.Element => {
  const visitorsChartData = getVisitorsChartData(months, userData);
  const documentChartData = getDocumentChartData(months, documentData);
  return (
    <>
      <div style={{ marginRight: '30px' }}>
        {loading ? (
          <Spinner height={300} width={300} color="#335153" />
        ) : (
          <Bar data={visitorsChartData} height={300} width={400} options={{ maintainAspectRatio: false }} />
        )}
      </div>
      <div>
        {loading ? (
          <Spinner height={300} width={300} color="#335153" />
        ) : (
          <Bar data={documentChartData} height={300} width={400} options={{ maintainAspectRatio: false }} />
        )}
      </div>
    </>
  );
};

export default React.memo(Charts);
